






import { Vue, Component, Inject } from "vue-property-decorator";
import { TranslateResult } from "vue-i18n";

@Component
export default class App extends Vue {
    @Inject() i18n!: (key: string, values?: unknown) => TranslateResult;

    created() {
        document.title = this.i18n("malta-customer-portal-title").toString();
    }
}
